import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],


};

const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    getUsers: (state, action) => {
      state.list = action.payload;
    },
    
    removeUser: (state, action) => {
      state.list = state.list.filter(
        (user) => user.id !== action.payload
      );
    },

    destroyUsertData: (state) => {
     
      state.list = [];
    
    },
  },

 
});


export const { getUsers, removeUser, destroyUsertData} = userSlice.actions;
export default userSlice.reducer;
